export default "__VITE_ASSET__9fa1ac54__"